import React from "react";
import {
  AttachmentSection,
  Button,
  Divider,
  FormFieldSet,
  Modal,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../../components";
import { v4 as uuidv4 } from "uuid";

const AddDependentPassport = ({ onClose, isOpen }) => {
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        dependent: "",
        passportNumber: "",
        status: "",
        placeOfIssue: "",
        placeOfBirth: "",
        issuedDate: "",
        expiryDate: "",
        issuingCountry: "",
        attachments: [
          {
            id: uuidv4(),
            attachmentName: "",
            attachmentComments: "",
            chooseFiles: [],
          },
        ],
      },
      {
        dependent: { type: "select", required: true },
        attachments: [ { chooseFiles: { type: "file" } } ]
      }
    );

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      console.log("form data:", formData);
      onClose();
    } else {
      console.log("error:", errors);
    }
  };

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };

  return (
    <Modal
      title={"ADD DEPENDENT PASSPORT DETAILS"}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-7xl"
    >
      <div>
        <div className="grid grid-cols-2 xl:grid-cols-3 mt-4 gap-x-6 gap-y-4 ">
          <FormFieldSet
            type="select"
            title={"Dependent"}
            placeholder="Select Dependent"
            value={formData.dependent}
            onChange={(value) => handleChange("dependent", value)}
            error={errors.dependent}
          />
          <FormFieldSet
            type="text"
            title={"Passport Number"}
            placeholder="Enter Passport Number"
            value={formData.passportNumber}
            onChange={(value) => handleChange("passportNumber", value)}
            error={errors.passportNumber}
          />
          <FormFieldSet
            type="select"
            title={"Status"}
            placeholder="Select Status"
            value={formData.status}
            onChange={(value) => handleChange("status", value)}
            error={errors.status}
          />
          <FormFieldSet
            type="text"
            title={"Place of Issue"}
            placeholder="Enter Place of Issue"
            value={formData.placeOfIssue}
            onChange={(value) => handleChange("placeOfIssue", value)}
            error={errors.placeOfIssue}
          />
          <FormFieldSet
            type="datepicker"
            title={"Place of Birth"}
            placeholder="Select Place of Birth"
            value={formData.placeOfBirth}
            onChange={(value) => handleChange("placeOfBirth", value)}
            error={errors.placeOfBirth}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Issued Date"}
            placeholder="Select Issued Date"
            value={formData.issuedDate}
            onChange={(value) => handleChange("issuedDate", value)}
            error={errors.issuedDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Expiry Date"}
            placeholder="Select Expiry Date"
            value={formData.expiryDate}
            onChange={(value) => handleChange("expiryDate", value)}
            error={errors.expiryDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="select"
            title={"Issuing Country"}
            placeholder="Select Issuing Country"
            value={formData.issuingCountry}
            onChange={(value) => handleChange("issuingCountry", value)}
            error={errors.issuingCountry}
          />
        </div>
        <div className="mt-6 ">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"ATTACHMENTS"} tag="p" />
              </div>
            }
          />
          <Divider />
        </div>
        <div>
          <div className="max-w-7xl">
            <AttachmentSection
              attachments={formData.attachments}
              onChange={(newAttachments) =>
                setFormData({ ...formData, attachments: newAttachments })
              }
              getAttachmentError={getAttachmentError}
              showNameField={true}
              showCommentsField={true}
            />
          </div>
        </div>

        <div className="flex gap-3 justify-end my-8">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button title={"Save"} onClick={() => handleSave()} />
        </div>
      </div>
    </Modal>
  );
};

export default AddDependentPassport;
